import React from "react";
import { slugify } from 'utils/misc';
import { getTeamLink, getLiveScoreLink } from 'utils/links';
import { Table } from 'react-bootstrap';


export default function MatchList({ matches, label, slim }) {

    if(!matches || matches.length ==0){
        return "";
    }
    if(slim){
     
        return <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Match</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {matches && matches.flat()
                        .sort((a, b) => new Date(a.MatchDate2) - new Date(b.MatchDate2))
                        .map((oneMatch, index) => (
                            <tr key={index}>
                              
                                <td>{oneMatch.Groupname} -{' '}
                                    <span className='fw-bold'>
                                        {oneMatch.Team1.TeamName} vs {oneMatch.Team2.TeamName}
                                    </span>
                                    <p className="p-0 m-0 small">{oneMatch.PlaygroundName}</p>
                                </td>
                                <td>{oneMatch.MatchDate2}</td>
                            </tr>
                        ))}

                </tbody>
            </Table>
    }
    return (
        <>
        <div className="d-none d-md-block">
            <Table size="sm" striped hover responsive>
                {matches && matches.length > 0 &&
                    <thead><tr key={0}>
                        <td colSpan="9">
                            <h2>{label}</h2>
                        </td>
                    </tr>
                        <tr>
                            <th>Date</th>
                            <th>Group</th>
                            <th>Team 1 vs Team 2</th>
                            <th>Ump Team 1</th>
                            <th>Ump Team 2</th>
                            <th>Venue</th>
                            <th>H2H</th>
                            <th>Match</th>
                            <th>Live</th>
                        </tr> </thead>}
                <tbody>
                    {matches && matches.flat()
                        .sort((a, b) => new Date(a.MatchDate2) - new Date(b.MatchDate2))
                        .map((oneMatch, index) => (
                            <tr key={(index + 1)}>
                                <td>{oneMatch.MatchDate2}</td>
                                <td>{oneMatch.Groupname}</td>
                                <td>
                                    {getTeamLink(oneMatch.Team1.TeamName, oneMatch.Team1.TeamId)} vs {getTeamLink(oneMatch.Team2.TeamName, oneMatch.Team2.TeamId)}
                                </td>
                                <td>{getTeamLink(oneMatch.UmpTeam1.TeamName, oneMatch.UmpTeam1.TeamId)}</td>
                                <td>{getTeamLink(oneMatch.UmpTeam2.TeamName, oneMatch.UmpTeam2.TeamId)}</td>
                                <td>{oneMatch.PlaygroundName}</td>
                                <td>
                                    <div>({oneMatch.Team1.TeamCount + '-' + oneMatch.Team2.TeamCount})</div>
                                </td>
                                <td><a href={"/match/" + slugify(oneMatch.Team1.TeamName + "-vs-" + oneMatch.Team2.TeamName) + "-" + oneMatch.MatchId}>Match</a></td>
                                <td> {getLiveScoreLink(oneMatch.MatchId)}</td>
                            </tr>
                        ))}
                </tbody>
            </Table>
            </div>

            <div className="d-md-none">
                <h2>{label}</h2>
                {matches && matches.flat()
                    .sort((a, b) => new Date(a.MatchDate2) - new Date(b.MatchDate2))
                    .map((oneMatch, index) => (
                        <div className="border p-2">
                            <p className='m-0 p-0 small'>
                                ({oneMatch.TournamentName}) {oneMatch.Groupname} on {oneMatch.MatchDate}
                            </p>
                            <p className='m-0 p-0 fw-bold'>
                                {getTeamLink(oneMatch.Team1.TeamName, oneMatch.Team1.TeamId)} vs {getTeamLink(oneMatch.Team2.TeamName, oneMatch.Team2.TeamId)}    ({oneMatch.Team1.TeamCount + '-' + oneMatch.Team2.TeamCount}) 
                            </p>
                            
                          
                           <div>
                                Umpires - {getTeamLink(oneMatch.UmpTeam1.TeamName, oneMatch.UmpTeam1.TeamId)} and {getTeamLink(oneMatch.UmpTeam2.TeamName, oneMatch.UmpTeam2.TeamId)}
                                <br />
                                Ground - {oneMatch.PlaygroundName}
                                <br/>
                                 <a href={"/match/" + slugify(oneMatch.Team1.TeamName + "-vs-" + oneMatch.Team2.TeamName) + "-" + oneMatch.MatchId}>Match</a> {' '}
                                 {getLiveScoreLink(oneMatch.MatchId)} 
                            </div>
                        </div>
                    ))}

            </div>
        </>

    )
}







